import config from 'config';

export function getSubdomain() {
  // Matches DLV's src/mixins/utils.js getSubdomainFromHost(): this app is
  // deployed single-tenant per environment (app.lichen.com always serves
  // the same org), so the subdomain always comes from config, never from
  // parsing the URL. The old localhost-only fallback below left every real
  // custom domain (app.lichen.com -> hostname "app") falling through to
  // hostname-parsing, which returned "app" and 404'd on /subdomain/app.
  if (config.defaultSubdomain) {
    return config.defaultSubdomain;
  }

  return window.location.hostname.split('.')[0];
}
